var _defs, _path, _ellipse, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polyline, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _circle, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polyline2, _polygon80, _path23, _polygon81, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _polygon82, _polyline3, _circle2, _circle3, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _circle4, _circle5, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _g, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _g2, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _polygon83, _polygon84, _polygon85, _polygon86, _rect, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _rect2, _rect3, _rect4, _rect5, _rect6, _path135, _path136, _path137, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _rect7, _rect8, _circle18, _circle19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eab39aaf-964c-43a5-8393-bd3b53d495e1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    viewBox: "0 0 1074.54 840.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dcdd7e1b-93ae-4349-854b-9912b47642c8",
    x1: 513.67,
    y1: 843.12,
    x2: 513.67,
    y2: 56.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "baby") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402,59.3C431.18,33.27,477,28,518.77,30c131.09,6.52,249.42,69.8,351.78,141.39,37.06,25.91,73.54,53.84,97.59,89.53,49,72.65,34.44,173.29-33.64,233.14-23.17,20.36-51.25,36-80.08,49.81-51.26,24.6-106.57,44.35-164.75,50-41.48,4-83.48.75-124.73-4.84C449.71,573.4,336.6,538.84,241.79,479.72,200.21,453.79,161,421.55,143.88,379.6s-6.17-95.11,36.29-119.94c17.56-10.27,38.56-14.91,59.11-19.27,30.26-6.41,61-12.73,88.3-25.76,28.21-13.46,61.6-39.49,56-69.29C377.6,113.37,372.8,85.3,402,59.3Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.93,
    cy: 788.9,
    rx: 133.14,
    ry: 41.68,
    fill: "#fbe1e5",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "733.95 360.24 738.78 616.96 749.05 618.17 745.18 359.22 733.95 360.24",
    fill: "#f5c5cc"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "739.87 355.45 745.38 622.64 749.05 618.17 745.18 359.22 739.87 355.45",
    fill: "none"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "709.12 355.41 713.95 612.13 724.22 613.34 720.35 354.39 709.12 355.41",
    fill: "#f5c5cc"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "715.04 350.62 720.54 617.81 724.22 613.34 720.35 354.39 715.04 350.62",
    fill: "none"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "715.19 341.99 715.69 621.99 726.19 620.99 722.19 336.49 715.19 341.99",
    fill: "#cc929b"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.56 295.24 429.99 527.95 440.26 529.03 436.8 294.3 425.56 295.24",
    fill: "#f5c5cc"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "431.49 290.89 436.57 533.09 440.26 529.03 436.8 294.3 431.49 290.89",
    fill: "#cc929b"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "447.41 301.13 451.84 533.83 462.11 534.91 458.65 300.19 447.41 301.13",
    fill: "#f5c5cc"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "453.34 296.77 458.43 538.97 462.11 534.91 458.65 300.19 453.34 296.77",
    fill: "#cc929b"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "468.77 307.51 473.2 540.22 483.47 541.3 480.01 306.58 468.77 307.51",
    fill: "#f5c5cc"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "474.7 303.17 479.79 545.36 483.47 541.3 480.01 306.58 474.7 303.17",
    fill: "#cc929b"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "489.55 308.81 494.11 549.69 504.38 550.81 500.78 307.85 489.55 308.81",
    fill: "#f5c5cc"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "495.47 304.31 500.7 555.01 504.38 550.81 500.78 307.85 495.47 304.31",
    fill: "#cc929b"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "512.08 310.69 516.65 551.56 526.92 552.68 523.32 309.72 512.08 310.69",
    fill: "#f5c5cc"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "518.01 306.19 523.24 556.88 526.92 552.68 523.32 309.72 518.01 306.19",
    fill: "#cc929b"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "534.22 318.56 538.78 559.44 549.05 560.56 545.46 317.6 534.22 318.56",
    fill: "#f5c5cc"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "540.14 314.06 545.37 564.76 549.05 560.56 545.46 317.6 540.14 314.06",
    fill: "#cc929b"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "559.56 323.76 564.24 571.36 574.51 572.51 570.8 322.77 559.56 323.76",
    fill: "#f5c5cc"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "565.48 319.14 570.83 576.83 574.51 572.51 570.8 322.77 565.48 319.14",
    fill: "#cc929b"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "581.61 326.39 586.28 573.99 596.56 575.14 592.84 325.4 581.61 326.39",
    fill: "#f5c5cc"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "587.53 321.76 592.88 579.46 596.56 575.14 592.84 325.4 587.53 321.76",
    fill: "#cc929b"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "604.97 332.99 609.65 580.59 619.92 581.75 616.21 332.01 604.97 332.99",
    fill: "#f5c5cc"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "610.9 328.37 616.24 586.07 619.92 581.75 616.21 332.01 610.9 328.37",
    fill: "#cc929b"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.55 294.83 405.05 280.09 410.25 277.25 783.19 353.74 783.88 372.45 405.55 294.83",
    fill: "#f5c5cc"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "410.25 277.25 784.56 353.68 784.18 360.69 405.82 279.66",
    fill: "#cc929b"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.69 661.67 415.19 665.49 405.19 665.49 404.69 270.95 410.19 263.31 415.5 261.75 422.19 260.74 425.69 661.67",
    fill: "#f5c5cc"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.69 661.67 415.19 665.49 414.54 271.73 415.5 261.75 422.19 260.74 425.69 661.67",
    fill: "#cc929b"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "630.35 340.32 635.03 587.91 645.3 589.07 641.59 339.33 630.35 340.32",
    fill: "#f5c5cc"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "636.27 335.69 641.62 593.39 645.3 589.07 641.59 339.33 636.27 335.69",
    fill: "#cc929b"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "655.92 344.23 660.69 597.12 670.96 598.3 667.15 343.23 655.92 344.23",
    fill: "#f5c5cc"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "661.84 339.51 667.28 602.71 670.96 598.3 667.15 343.23 661.84 339.51",
    fill: "none"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "682.25 348.86 687.08 605.58 697.35 606.79 693.49 347.84 682.25 348.86",
    fill: "#f5c5cc"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "688.17 344.07 693.68 611.27 697.35 606.79 693.49 347.84 688.17 344.07",
    fill: "#cc929b"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "280.19 585.99 269.69 586.99 269.2 310.8 269.19 306.99 276.19 301.49 276.3 309.15 280.19 585.99",
    fill: "#f5c5cc"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.19 570.49 306.69 571.49 306.2 299.81 306.19 291.49 313.19 285.99 313.35 297.15 317.19 570.49",
    fill: "#f5c5cc"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "378.19 545.49 367.69 546.49 367.21 278.24 367.19 266.49 374.19 260.99 374.41 276.57 378.19 545.49",
    fill: "#f5c5cc"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.69 535.49 394.19 536.49 393.72 274.79 393.69 256.49 400.69 250.99 401.05 276.41 404.69 535.49",
    fill: "#f5c5cc"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "298.69 582.99 288.19 583.99 287.69 305.99 287.69 303.99 294.69 298.49 294.76 303.76 298.69 582.99",
    fill: "#f5c5cc"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "352.69 557.99 342.19 558.99 341.7 286.23 341.69 278.99 348.69 273.49 348.83 283.75 352.69 557.99",
    fill: "#f5c5cc"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "335.19 562.99 324.69 563.99 324.21 292.88 324.19 283.99 331.19 278.49 331.35 290.07 335.19 562.99",
    fill: "#f5c5cc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M331.72,569.48l-2.5,5.25s-6.5,9.75-5.75,24.75S313,654.23,313,654.23s10.25,4.75,18,4.25,24.5,7.75,24.5,7.75L390.22,677l70.25,16.5s41.25,23,52.5,23,56,15.25,56,15.25S629.47,745,634.22,750,659,761.73,661,762s32.5,3.25,32.5,3.25,35.5,8.25,40.5-.5a45.08,45.08,0,0,0,5.75-16s15.75,3.5,20-1.75,4.5-16.5,9.5-16,25.5,6.75,27.75,4.5,14.25-28.75,22.75-24.75S843,721,843,721l-8.5-86.5-3.75-23.75s-136.25,55.5-141,55.5S331.72,569.48,331.72,569.48Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M830,493.73l-.75,122L687.72,670l-358.5-95.25s-24.25-34.25-1.75-66.25c0,0-29-40,7-66l.89-.21,136.11-32.79L532,420.56l267.45,48.92S825.72,479.23,830,493.73Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M527.22,432.23c-6.75,3.5-55.75,16.25-65.5,24S384.47,470,384.47,470l-7.5,1.5s.5-5-29.25-19.5a37.93,37.93,0,0,1-12.36-9.71l136.11-32.79L532,420.56C532.08,425.35,531.26,430.13,527.22,432.23Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.47,384s-2.5,48.5,27.25,63S378,466.48,378,466.48l7.5-1.5s-26-29-24.25-34S338,400.73,334.47,399.73,321.47,384,321.47,384Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M322,384.73s-2.5,48.5,27.25,63,29.25,19.5,29.25,19.5l7.5-1.5s-26-29-24.25-34S338.47,401.48,335,400.48,322,384.73,322,384.73Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329,405.23s24,36.25,28.25,37.5S334.72,405.73,329,405.23Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M318,377.23s15.5-12.5,17.5-15,24-3.5,24.75-3.5,17.5-10.25,36.25-13.5,26.25-4.75,26.25-4.75,27.5-11.5,29-14,14.25-5.25,30,7,50.5,67.25,50.75,73.25,2.5,17-4.25,20.5-55.75,16.25-65.5,24S385.47,465,385.47,465L360,437.23l-13.5-21.75L324,391.73Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M359.8,593.15s-9.33,2-4,7.33S359.8,593.15,359.8,593.15Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M392.47,603.82s-10,12-8,15.33S392.47,603.82,392.47,603.82Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M451.14,619.15s-10,12-8,15.33S451.14,619.15,451.14,619.15Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M522.47,639.15s-10,12-8,15.33S522.47,639.15,522.47,639.15Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M618.47,663.15s-10,12-8,15.33S618.47,663.15,618.47,663.15Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M421.14,607.15s-10,12-8,15.33S421.14,607.15,421.14,607.15Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M560.47,649.15s-10,12-8,15.33S560.47,649.15,560.47,649.15Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M589.8,658.48s-10,12-8,15.34S589.8,658.48,589.8,658.48Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M477.14,627.15s-10,12-8,15.33S477.14,627.15,477.14,627.15Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M729.14,699.82l10.58,48.91S739.8,714.48,729.14,699.82Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M761.8,707.15,769.22,731S768.47,721.82,761.8,707.15Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M797,735.48s-15.83-57.66-19.17-61.66S787.47,731.82,797,735.48Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M815.8,708.48s-18.66-32.66-11.33-38.66S815.8,708.48,815.8,708.48Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M327.47,508.48,689.8,589.82l139.34-40.67L688.47,585.82S338.47,505.15,327.47,508.48Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "275.69 390.49 276.19 623.24 286.44 624.49 286.94 389.74 275.69 390.49",
    fill: "#f5c5cc"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.69 386.24 282.69 628.49 286.44 624.49 286.94 389.74 281.69 386.24",
    fill: "#cc929b"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "297.44 396.74 297.94 629.49 308.19 630.74 308.69 395.99 297.44 396.74",
    fill: "#f5c5cc"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.44 392.49 304.44 634.74 308.19 630.74 308.69 395.99 303.44 392.49",
    fill: "#cc929b"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "318.69 403.49 319.19 636.24 329.44 637.49 329.94 402.74 318.69 403.49",
    fill: "#f5c5cc"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.69 399.24 325.69 641.49 329.44 637.49 329.94 402.74 324.69 399.24",
    fill: "#cc929b"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.44 405.14 339.94 646.06 350.19 647.35 350.69 404.36 339.44 405.14",
    fill: "#f5c5cc"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    points: "345.44 400.74 346.44 651.49 350.19 647.35 350.69 404.36 345.44 400.74",
    fill: "#cc929b"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    points: "361.94 407.39 362.44 648.31 372.69 649.6 373.19 406.61 361.94 407.39",
    fill: "#f5c5cc"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.94 402.99 368.94 653.74 372.69 649.6 373.19 406.61 367.94 402.99",
    fill: "#cc929b"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    points: "383.94 415.64 384.44 656.56 394.69 657.85 395.19 414.86 383.94 415.64",
    fill: "#f5c5cc"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    points: "389.94 411.24 390.94 661.99 394.69 657.85 395.19 414.86 389.94 411.24",
    fill: "#cc929b"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.19 421.26 409.69 668.9 419.94 670.23 420.44 420.46 409.19 421.26",
    fill: "none"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    points: "415.19 416.74 416.19 674.49 419.94 670.23 420.44 420.46 415.19 416.74",
    fill: "#cc929b"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    points: "431.19 424.26 431.69 671.9 441.94 673.23 442.44 423.46 431.19 424.26",
    fill: "#f5c5cc"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    points: "437.19 419.74 438.19 677.49 441.94 673.23 442.44 423.46 437.19 419.74",
    fill: "#cc929b"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    points: "454.44 431.26 454.94 678.9 465.19 680.23 465.69 430.46 454.44 431.26",
    fill: "#f5c5cc"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    points: "460.44 426.74 461.44 684.49 465.19 680.23 465.69 430.46 460.44 426.74",
    fill: "#cc929b"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    points: "479.69 439.01 480.19 686.65 490.44 687.98 490.94 438.21 479.69 439.01",
    fill: "#f5c5cc"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    points: "485.69 434.49 486.69 692.24 490.44 687.98 490.94 438.21 485.69 434.49",
    fill: "#cc929b"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    points: "505.19 443.36 505.69 696.28 515.94 697.64 516.44 442.54 505.19 443.36",
    fill: "#f5c5cc"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    points: "511.19 438.74 512.19 701.99 515.94 697.64 516.44 442.54 511.19 438.74",
    fill: "#cc929b"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    points: "531.44 448.43 531.94 705.2 542.19 706.58 542.69 447.6 531.44 448.43",
    fill: "#cc929b"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    points: "537.44 443.74 538.44 710.99 542.19 706.58 542.69 447.6 537.44 443.74",
    fill: "none"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    points: "558.19 455.43 558.69 712.2 568.94 713.58 569.44 454.6 558.19 455.43",
    fill: "#f5c5cc"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    points: "564.19 450.74 565.19 717.99 568.94 713.58 569.44 454.6 564.19 450.74",
    fill: "#cc929b"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    points: "582.94 460.68 583.44 717.45 593.69 718.83 594.19 459.85 582.94 460.68",
    fill: "#cc929b"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    points: "588.94 455.99 589.94 723.24 593.69 718.83 594.19 459.85 588.94 455.99",
    fill: "none"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    points: "262.19 668.49 251.69 672.49 241.69 672.49 241.19 305.49 246.69 297.49 252 295.86 259.69 293.49 262.19 668.49",
    fill: "#f5c5cc"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    points: "262.19 668.49 251.69 672.49 251.04 306.3 252 295.86 259.69 293.49 262.19 668.49",
    fill: "#cc929b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 252.69,
    cy: 671.99,
    r: 12,
    fill: "#40414d"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    points: "799.19 724.67 788.69 728.49 778.69 728.49 778.19 324.95 783.69 326.31 789 324.75 796.69 322.49 799.19 724.67",
    fill: "#f5c5cc"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    points: "799.19 724.67 788.69 728.49 788.04 334.73 789 324.75 796.69 322.49 799.19 724.67",
    fill: "#cc929b"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    points: "653.69 648.99 643.19 649.99 642.71 380.4 642.69 369.99 649.69 364.49 649.89 378.86 653.69 648.99",
    fill: "#f5c5cc"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    points: "690.69 633.49 680.19 634.49 679.72 369.88 679.69 354.49 686.69 348.99 686.95 367.25 690.69 633.49",
    fill: "#f5c5cc"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    points: "751.69 608.49 741.19 609.49 740.72 345.5 740.69 329.49 747.69 323.99 747.95 342.5 751.69 608.49",
    fill: "#f5c5cc"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    points: "767.19 319.49 767.69 599.49 778.19 598.49 774.19 313.99 767.19 319.49",
    fill: "#f5c5cc"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    points: "672.19 645.99 661.69 646.99 661.21 375.87 661.19 366.99 668.19 361.49 668.36 373.7 672.19 645.99",
    fill: "#f5c5cc"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    points: "708.69 625.99 698.19 626.99 697.72 363.08 697.69 346.99 704.69 341.49 704.95 360.17 708.69 625.99",
    fill: "#f5c5cc"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    points: "729.02 619.32 718.52 620.32 718.05 356.41 718.05 354.84 718.02 340.32 725.02 334.82 725.26 351.88 725.28 353.5 729.02 619.32",
    fill: "#f5c5cc"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    points: "632.69 647.16 777.69 585.49 787.69 587.82 788.02 610.82 635.36 669.82 632.69 647.16",
    fill: "#f5c5cc"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "777.69 585.49 632.69 647.16 787.15 587.69",
    fill: "#cc929b"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 614.49 622.69 725.49 622.02 743.49 255.69 630.49 257.02 614.49",
    fill: "#f5c5cc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M701.42,818.12l-10.5,4h-10l-.5-411h0v-2l.78-1.14,4.72-6.86,5.31-1.63,7.69-2.37.08,14Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#f5c5cc"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    points: "638.69 788.49 628.19 792.49 627.54 380.3 628.5 369.86 636.19 367.49 638.69 788.49",
    fill: "#cc929b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M698.92,397.12l.08,14a85.24,85.24,0,0,1-8.73.82c-7.2.28-9.85-.81-9.85-.81h0c0-.14.28-1.26.78-3.13l4.72-6.86,5.31-1.63Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M712.42,394.12l.2,14.37q-3.87.9-7.18,1.54l0-10.41Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M730.92,391.12l.17,12.21c-2.49.79-4.88,1.51-7.15,2.17l0-8.88Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M749.42,378.62l.26,18.26q-3.75,1.39-7.23,2.63l0-15.39Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M767.42,371.12l.26,18.68-5.76,2.32-1.47.59,0-16.09Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M810.68,372.13l-7.23,3,0-16,7-5.5Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M788,381.51l-7.21,3,0-14.52,7-5.5Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M865.42,361.12s-18.5,0-23.5-1.5-15.5,4.5-80,30.5c-39,15.73-60.65,19.38-71.65,19.81-7.2.28-9.85-.81-9.85-.81s13.17-60.42,55.11-71.71a124.39,124.39,0,0,0,13.77-4.63l.81-.31a82,82,0,0,1,10.81-3.35c13.46-3.09,23.07-9,47.4-9.18A66.55,66.55,0,0,1,850.1,333.8C858.44,340.36,865.63,349.43,865.42,361.12Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#cc929b"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M751.92,332.12c-51.9,22.38-59.82,64.21-61.65,77.81-7.2.28-9.85-.81-9.85-.81s13.17-60.42,55.11-71.71a124.39,124.39,0,0,0,13.77-4.63l.81-.31C750.71,332.38,751.31,332.26,751.92,332.12Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#f5c5cc"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M338.92,331.12l.11,7.66c-2.53.63-4.89,1.18-7.1,1.65v-3.81Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M357.42,328.12l.07,5.27q-3.69,1.22-7.07,2.23v-2Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M375.92,315.62l.16,11.16q-3.69,1.41-7.15,2.66v-8.32Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M393.92,308.12l.16,11.58q-3.45,1.33-7.14,2.81l0-8.89Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M411.42,303.12l.14,10.26q-3.4,1.14-7.13,2.48v-7.24Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M436.92,290.62l.22,15.58c-2.21.46-4.6,1-7.2,1.67l0-11.75Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M463.78,306a26.37,26.37,0,0,0-7.33-1.62l0-18.3,7-5.5Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M488.92,306.12s-18.5,0-23.5-1.5-15.5-9.5-80,16.5c-39,15.73-60.65,19.38-71.65,19.81-7.2.28-9.85-.81-9.85-.81s9.93-52.5,53.72-61.36a64.38,64.38,0,0,0,7.23-1.85c2.69-.88,6.93-2.14,12.63-3.45,14.7-3.38,39.07-7.09,71.46-5.52A44.32,44.32,0,0,1,478.75,281,34.31,34.31,0,0,1,488.92,306.12Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#cc929b"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M377.5,273.46c-51.9,22.38-61.9,53.87-63.73,67.47-7.2.28-9.85-.81-9.85-.81s9.93-52.5,53.72-61.36a64.38,64.38,0,0,0,7.23-1.85C367.56,276,371.8,274.77,377.5,273.46Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#f5c5cc"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    points: "255.69 389.74 255.44 374.99 260.69 372.24 619.69 452.74 618.69 471.49 255.69 389.74",
    fill: "#f5c5cc"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "260.69 372.24 619.69 452.74 619.19 459.74 256.22 374.58",
    fill: "#cc929b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 788.69,
    cy: 728.49,
    r: 12,
    fill: "#40414d"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.69,
    cy: 796.49,
    r: 12,
    fill: "#40414d"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M332.09,579.45s-10.67,12-14,22.67,4,50.67,4,50.67a73.65,73.65,0,0,0,8-21.34C332.75,618.79,332.09,579.45,332.09,579.45Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M838.42,679.12s6.5,33,7,38-16.5-2.5-16.5-2.5Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M641.42,270.81l-.17,0a2,2,0,0,0-.37-.94,4.91,4.91,0,0,0-1.66-1.26L634.53,266l4.05,1.47a9.05,9.05,0,0,0-.63-.94l.47.26-.32-.45-.43-.15c-2.16-2.53-5.76-3.58-9.25-3.53h.06c.45-.06.91-.1,1.36-.13a16.23,16.23,0,0,0-3,.09h0a1.4,1.4,0,0,0,.35.1c-.32,0-.64.06-1,.1a3,3,0,0,1-1.57,0,2.27,2.27,0,0,1-1.21-1.65c-.5-2,.29-4.15.52-6.24a6.69,6.69,0,0,0-.31-2.91c0-.2,0-.4,0-.6a3,3,0,0,0-2-1.84,1.85,1.85,0,0,0,0,.23l-.17-.07c0,1.79,0,3.59,0,5.38a21.45,21.45,0,0,1-4.09-4.26,1.87,1.87,0,0,1-.41-.85c-.1-.91,1.06-1.54,1.13-2.46a1.37,1.37,0,0,0-1-1.3l.3-.11a2.25,2.25,0,0,0-1.14-.2,19.16,19.16,0,0,0-2.52.76l.26.05a5.69,5.69,0,0,1-.59.16c-2.51.52-4.75-1.48-6.56-3.29l-.39-.39c-.86-7.53-2.25-16.16-2.25-16.16s-1.25-9.86-3-15.16-4.27-14.66-4.27-14.66-5.76-11.37-7-11.87a15.27,15.27,0,0,1-1.41-.8,22.39,22.39,0,0,1-1-5.24c-.31-9.94,10.31-17,11.91-26.85,1.31-8-3.73-16-3-24.11.34-3.55,1.77-6.89,2.54-10.37a27.93,27.93,0,0,0,.29-10.27,16.93,16.93,0,0,0-1.64-5.27,28.46,28.46,0,0,0,3.61-6.11c1.62-4.62-.13-9.78-2.66-14-8.13-13.43-24.6-24-40-25.37-6.21-.57-12.44-.68-18.66-.78-7.14-.13-14.52-.21-21.12,2.55-13.12,5.49-19.33,20.16-27.3,32a90.72,90.72,0,0,1-24.82,24.77c-4.61,3.08-10,6.36-11.08,11.83a10.77,10.77,0,0,0-.19,1.59,14.66,14.66,0,0,1-.33-1.46c-1.09,5.71,2.94,11,5,16.45a29,29,0,0,1,1.84,8.89,38.88,38.88,0,0,0,0-4.32c2,10.38-1.67,21.52-3.94,32.13-.17.78-.3,1.56-.46,2.34a19.13,19.13,0,0,0-5.26,2.37,29.58,29.58,0,0,1-11.82,4.6,22.08,22.08,0,0,0-14.22,8.54c-.64.86-1.26,1.45-1.8,1.51-2.25.26-14.79,39.42-14.79,39.42S407,255.55,407,259.33s-4.51,31.08-4.51,31.08-1.51,5-1,7.07c.29,1.15-.4,5-1.05,8.1a1.8,1.8,0,0,1-.7-.52c-.75-1.51-14.55,0-10.28,10.11a19.82,19.82,0,0,0,4.83,7.18c-1.9,4.76-3.55,9.19-3.33,9.75,0,0,0,3.61.32,8.07-2.93,2-5.33,3.8-5.33,3.8-.21,5.52,3.47,6.4,6.93,6.2.89,3.2,2.19,5.74,4.1,6.43,6.27,2.28,10.28,1.27,12.29,3S422,364.69,422,364.69A126.76,126.76,0,0,0,435.74,366l1.84.92-.22-1c.59-.11.32-.81-.42-2-.33-1.53-.75-3.53-1.22-5.81l2.75-1,.75,1.11c-1,5.24-1.64,8.73-1.64,8.73s-5,17.94-2.76,20.72,0,6.32,0,6.32-.5,4.54.76,4.54,2.75,5.81,1.5,6.07-7,5.05-5,6.06,0,3.28,0,5.56c0,1.66,3.06,4.12,4.72,5.33-.3,1.08-.61,2.23-.9,3.36-.86,3.34-1.53,6.56-1.32,7.73.5,2.78-1.25,10.61-.75,13.14s2.26,8.08,1,10.36.25,9.85.25,9.85l2.26,21.47s-1.5,6.07,0,7.58,2.76,19.21,4.26,21.23,3.77,12.63,2,16.17,2.26,10.86,2.26,10.86-.25,8.59-.25,10.86,2.25,5.81,2.25,5.81,2.26,12.13,2,15.16,1.5,7.33,1.5,7.33,1.51,8.84,1.26,10.86,2,4.8,2,4.8,2.76,6.57,2,9.35,1.75,5.56,1.75,5.56-.25,6.06-.25,6.82,5.27,6.82,5.27,6.82-2.26,4.55-1,6.32,1,8.08,3,10.11,1.5,10.35,4,11.87,4.76,2.78,5.26,6.06,2.51,8.09,4.77,8.85a4.35,4.35,0,0,1,1.1,1.09l-1,4.25-3.09,12.85s-3,18.69-2.76,21.47-3,5.56-3,5.56-2.76,16.17-3.26,18.19.25,5.81.25,5.81-1.75,9.6-.5,10.11,6.52,5.81,6.52,5.81h.41l-.54,1.9-8.65,30.7s-8,13.39,10.54,20.21c.62,1.2,1.19,1.23.52,1,.61.52,13,11,14,15.91s9.53,10.1,12.54,10.61,23.07,16.67,30.34.76-12.79-26.28-12.79-26.28L504.78,800s-7.77-11.37-9-13.39-3.51-11.88-2-13.39c.77-.78,3.18-7.7,5.36-14.28.2-.63.41-1.25.61-1.87,4.26,1,9.08-1,9.08-1L520,738.45l2-3.09.36.72s9.28.76,13.79,1.52a13,13,0,0,0,4.24-.53c.17.37.34.75.5,1.13a55.3,55.3,0,0,1,2.78,7.23c.75,3.28,1.51,14.9,1.51,14.9s-5,16.68-6.27,19.71,1.25,28.3,26.08,18.19c0,0,3-4.8,5.76-4.8s9.53-6.82,7-14.15-13-29.81-5.76-41.68c5.84-9.56,5.37-22.38-2.48-28.34-.33-.25-.68-.47-1-.69a28.64,28.64,0,0,0,0-3.82c-1.76-24.25-13-25.52-13-25.52s-6.52-1.51-7.27-4c-.44-1.46-6.09-9-10.77-15.13.16-.26.31-.52.46-.78,0-.09.1-.18.14-.27.22-.41.43-.83.63-1.27,3.64-8.18,2.7-20.08,2.51-22.21-.25-2.78,0-6.32,0-10.36s4-10.11,3.51-12.38,4.77-11.62,4.77-13.9S553.18,583,553.18,583s7.27-15.67,8.78-20.22c1.44-4.36,27.12-83.84,29.2-90.28a3.91,3.91,0,0,1,.14-.42s8.2-26.83,2.71-44.45a28.25,28.25,0,0,0-1.29-3.41c1.68-.81,2.84-1.4,2.84-1.4s-3.26-9.6-1.76-13.14.5-10.36.5-10.36-6-3.54-6.26-5.05-2.76-3.54-2-5.56,5-1,4.51-5.56-5.76-9.35-5.26-12.13,2.5-7.83,0-10.86-3.51-7.83-3.76-11.62c-.07-1,.15-3.95.5-7.84a88.06,88.06,0,0,0,8.27,4.55s10.78,1.52,11.29.51a23.77,23.77,0,0,1,3.26-3.54c13.54-3.28,7.52-28,7.52-28s-.2-1.81-.52-4.79a2.63,2.63,0,0,0,.94-.45c1.15-.84,1.43-2.44,2.13-3.7a18.38,18.38,0,0,1,2.78-3.26c2.48-2.7,3.95-6.15,5.37-9.54.9-2.16,1.82-4.32,2.73-6.49s2-4.76,4-6.33c2.3-1.85,5.42-2.21,8.35-2.48a10.45,10.45,0,0,0-2.39-6.12,6.14,6.14,0,0,1,5.26.8,2.12,2.12,0,0,0,.11-.21l.06,0A1.35,1.35,0,0,0,641.42,270.81ZM427.29,340c.06-.5.15-1,.26-1.5.49-.46,1.08-1,1.71-1.5l3.5.34c-.86.7-1.61,1.34-2.22,1.86C429.46,338.65,428.28,339.19,427.29,340Zm7-6.93a5.38,5.38,0,0,0,1.45-.31c.67,0,1.36,0,2.06,0l1,0c-1.67,1.17-3.36,2.47-4.86,3.68l.35-3.29Zm5.77-51s-.23,7.18.28,14.4c-.78.55-1.59,1.15-2.39,1.78l1.77-16.65Z",
    transform: "translate(-62.73 -29.63)",
    fill: "url(#dcdd7e1b-93ae-4349-854b-9912b47642c8)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M570.67,792.37c-2.75,0-5.75,4.75-5.75,4.75-24.75,10-27.25-15-26-18s6.25-19.5,6.25-19.5-.75-11.5-1.5-14.75a55.77,55.77,0,0,0-2.77-7.15c-1.68-3.83-3.48-7.6-3.48-7.6s10.75-26.5,25-24a16.08,16.08,0,0,1,7,3c7.83,5.9,8.3,18.59,2.47,28-7.25,11.75,3.25,34,5.75,41.25S573.42,792.37,570.67,792.37Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fdc2cc"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M532.92,834.62c-7.25,15.75-27.25-.25-30.25-.75s-11.5-5.5-12.5-10.5-13.37-15.23-14-15.74c.67.21.1.18-.52-1-18.5-6.75-10.5-20-10.5-20l8.62-30.38,2.38-8.37,27-1.75s-1.85,5.91-3.91,12.12c-2.17,6.51-4.57,13.36-5.34,14.13-1.5,1.5.75,11.25,2,13.25s9,13.25,9,13.25l15.25,9.75S540.17,818.87,532.92,834.62Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fdc2cc"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M503.17,746.12s-1.85,5.91-3.91,12.12a7.19,7.19,0,0,1-3.59-2.37l-21.75.5-.13-.13,2.38-8.37Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M591.17,474.37s0,.14-.13.41c-2.08,6.37-27.68,85-29.12,89.34-1.5,4.5-8.75,20-8.75,20s-3.75,13.5-3.75,15.75-5.25,11.5-4.75,13.75-3.5,8.25-3.5,12.25-.25,7.5,0,10.25c.19,2.11,1.12,13.89-2.51,22a14.79,14.79,0,0,1-3.45,5,10.71,10.71,0,0,1-1.29,1c-9,6-9.75,67.5-9.75,67.5l-.42.66L520.1,738l-11.18,17.4s-9,3.75-13.25-1.5l-21.75.5s-5.25-5.25-6.5-5.75.5-10,.5-10-.75-3.75-.25-5.75,3.25-18,3.25-18,3.25-2.75,3-5.5,2.75-21.25,2.75-21.25l3.08-12.71,1.52-6.27,3.15-13,21.25-187.75,27-8.25,52,2.5,5.7,10.3Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#5f5d7e"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M517.92,566.62c-.25,4.75-1.5,12-1,16.25s2.25,20.25,1.5,23.25,2.75,6.5,4,8,.5,6,.75,9.5,3.5,6.75,3.5,6.75-3.75,8-1,9.25,8.5,12.75,8.5,12.75,1.93,2.43,4.49,5.73a13.71,13.71,0,0,1-4.74,6c-9,6-9.75,67.5-9.75,67.5l-.42.66-5.58-11.16s-33.25-50.25-35.5-51a3.52,3.52,0,0,1-1.4-1l3.15-13,21.25-187.75,27-8.25,52,2.5-27.38,2.75s-12.17,8.73-12.25,9l-21.87,9.25-4,60S518.17,561.87,517.92,566.62Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M590.37,472.92c-.69,2.78-72.7-5.55-72.7-5.55l.5,19.25-4,60s-1,18.25-1.25,23-1.5,12-1,16.25,2.25,20.25,1.5,23.25,2.75,6.5,4,8,.5,6,.75,9.5,3.5,6.75,3.5,6.75-3.75,8-1,9.25,8.5,12.75,8.5,12.75,2.75,3.47,6,7.73a10.71,10.71,0,0,1-1.29,1c-9,6-9.75,67.5-9.75,67.5l-.42.66L520.1,738l-6.93-13.85s-25.65-38.77-33.42-48.71l1.52-6.27,3.15-13,21.25-187.75,27-8.25,52,2.5Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M569.45,709.08c-1,17.9-19.86,26.66-28.55,28.64-1.68-3.83-3.48-7.6-3.48-7.6s10.75-26.5,25-24A16.08,16.08,0,0,1,569.45,709.08Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M514.92,566.62c-.25,4.75-1.5,12-1,16.25s2.25,20.25,1.5,23.25,2.75,6.5,4,8,.5,6,.75,9.5,3.5,6.75,3.5,6.75-3.75,8-1,9.25,8.5,12.75,8.5,12.75,16.25,20.5,17,23,7.25,4,7.25,4,11.25,1.25,13,25.25-27.75,33.25-32.25,32.5-13.75-1.5-13.75-1.5l-7.25-14.5s-33.25-50.25-35.5-51-4.25-5.5-4.75-8.75-2.75-4.5-5.25-6-2-9.75-4-11.75-1.75-8.25-3-10,1-6.25,1-6.25-5.25-6-5.25-6.75.25-6.75.25-6.75-2.5-2.75-1.75-5.5-2-9.25-2-9.25-2.25-2.75-2-4.75-1.25-10.75-1.25-10.75-1.75-4.25-1.5-7.25-2-15-2-15-2.25-3.5-2.25-5.75.25-10.75.25-10.75-4-7.25-2.25-10.75-.5-14-2-16-2.75-19.5-4.25-21,0-7.5,0-7.5l-2.25-21.25s-1.5-7.5-.25-9.75-.5-7.75-1-10.25,1.25-10.25.75-13c-.21-1.16.46-4.34,1.31-7.65,1.18-4.56,2.69-9.35,2.69-9.35s128.5-12,147,.5c4,2.68,6.47,6.75,8,11.51,5.47,17.44-2.71,44-2.71,44l-71,9.25-4,60S515.17,561.87,514.92,566.62Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#5f5d7e"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M494.42,655.62s22.25-6.75,27.5-2.25S494.42,655.62,494.42,655.62Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M502.42,684.12s6.75-7.25,16.75-5a27.25,27.25,0,0,0,17.5-1.75Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M525.92,692.37s18.25-2.5,19-.25S525.92,692.37,525.92,692.37Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M520.67,707.12s20.25-6,21.25-3.5-22.25,3.25-22.25,3.25Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M543.42,572.37s-19,16.75-16.25,18.5S543.42,572.37,543.42,572.37Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M527.92,613.87s13.25,0,10.75,3S527.92,613.87,527.92,613.87Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M535.92,625.62s-5.25,4.5-4,5.5S535.92,625.62,535.92,625.62Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M478.17,732.87s16.5,5.5,16.75,9S478.17,732.87,478.17,732.87Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M558.17,210.12l-5.25,31.25s-45.5,24-46.25,24-33.25-5.5-34.5-5.5-22.5-64.25-7.5-68.25c4.06-1.08,9.95-3.68,16.38-6.91,17.34-8.67,38.62-21.84,38.62-21.84s31.75-3.5,24,18.5c-3,8.63-1.46,14.91,1.57,19.36C550,207.63,558.17,210.12,558.17,210.12Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fdc2cc"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M558.17,210.12l-5.25,31.25s-45.5,24-46.25,24-33.25-5.5-34.5-5.5-22.5-64.25-7.5-68.25c4.06-1.08,9.95-3.68,16.38-6.91,4.09.27,6.87.66,6.87.66s10,38.25,10.75,50,26.75,13,28.5,12.5,9-29.25,9-29.25-.75-10,1.5-10c1.88,0,6.22-6,7.57-7.89C550,207.63,558.17,210.12,558.17,210.12Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M593.88,430.38c-3.48,1.7-11.8,5.58-14,5-2.75-.75-9.5-.75-9.5-.75s-4,4.5-8.25,3.5-21-.25-21-.25-30,1.25-35.75-.75-26.25-3.75-26.25-3.75-28-3.25-32.75-5.25a8.19,8.19,0,0,0-8.25,1s-.87-.57-1.94-1.4c1.18-4.56,2.69-9.35,2.69-9.35s128.5-12,147,.5C589.88,421.55,592.39,425.62,593.88,430.38Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M487.92,187.37s-25.25-3.5-35.25,3.25a29.58,29.58,0,0,1-11.78,4.55,22.05,22.05,0,0,0-14.18,8.45c-.64.86-1.26,1.44-1.79,1.5-2.25.25-14.75,39-14.75,39l30.25,42.25s-.75,23.5,3.5,28-6,56-6,56-5,17.75-2.75,20.5,0,6.25,0,6.25-.5,4.5.75,4.5,2.75,5.75,1.5,6-7,5-5,6,0,3.25,0,5.5,5.75,6,5.75,6a8.19,8.19,0,0,1,8.25-1c4.75,2,32.75,5.25,32.75,5.25s20.5,1.75,26.25,3.75,35.75.75,35.75.75,16.75-.75,21,.25,8.25-3.5,8.25-3.5,6.75,0,9.5.75,15.5-5.75,15.5-5.75-3.25-9.5-1.75-13,.5-10.25.5-10.25-6-3.5-6.25-5-2.75-3.5-2-5.5,5-1,4.5-5.5-5.75-9.25-5.25-12,2.5-7.75,0-10.75-3.5-7.75-3.75-11.5,3.75-37.75,3.75-37.75l-9.25-68.5,28.25-14s-1.25-9.75-3-15-4.25-14.5-4.25-14.5-5.75-11.25-7-11.75-14.5-9.25-17.5-8-26.75,19.5-26.75,19.5-5.75,8.5-8,8.5-1.5,10-1.5,10-7.25,28.75-9,29.25-27.75-.75-28.5-12.5S487.92,187.37,487.92,187.37Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#d39999"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M448.72,335.18a56.69,56.69,0,0,1-10.55,1.3c-5.13.14-9.64-.51-10.75-2.36-3-5-3-14.5-3-14.5s13.56,3.13,22.92,6.55l1.55.58h0c3.63,1.41,6.39,2.85,7,4.11C456.76,332.55,453.41,334.13,448.72,335.18Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fdc2cc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 484.19,
    cy: 120.74,
    r: 45.75,
    opacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 484.19,
    cy: 118.74,
    r: 45.75,
    fill: "#fdc2cc"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M445.67,395.37s13,0,18,1.25,15.5,1.5,15.5,1.5S450.17,397.12,445.67,395.37Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M446.17,403.37s16.75,1.25,17,3.75S446.17,403.37,446.17,403.37Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M573.67,372.62s10.25,3.75,10,5S574.67,375.62,573.67,372.62Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M416.67,239.62l-6.5,4.5s-2.75,16-2.75,19.75-4.5,30.75-4.5,30.75-1.5,5-1,7-2,12.25-2,12.25-9,20.75-8.5,22,42.75,5.25,42.75,5.25l6-56Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#d39999"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M397.67,329.12l-6.25,6.75s-.25,22,6,24.25,10.25,1.25,12.25,3,12.75,5,12.75,5,11.75,1.75,15.25,1.25-20.5-19.75-4.75-36Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#d39999"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M595.42,222.12l8.75,9.75s3.75,23.25,2.75,26.5,5.25,59.75,5.25,59.75,6,24.5-7.5,27.75a23.59,23.59,0,0,0-3.25,3.5c-.5,1-11.25-.5-11.25-.5l-16.5-108.25Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#d39999"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M476.42,311.62s32.75-19.5,38.75-20.5,43.25-18.75,43.25-18.75,18.5,9.5,20.25,16.75-7.75,36.25-7.75,36.25-30.5,21.25-32.25,25.75-28,17.75-28,20-41.5,26.75-59.75,5.25-18-27.75-18-27.75l46.25-10.75,4.5-20Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M476.42,309.62s32.75-19.5,38.75-20.5,43.25-18.75,43.25-18.75,18.5,9.5,20.25,16.75-7.75,36.25-7.75,36.25-30.5,21.25-32.25,25.75-28,17.75-28,20-41.5,26.75-59.75,5.25-18-27.75-18-27.75l46.25-10.75,4.5-20Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#c4c8e2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M425.92,318.37l-1.5,12.5L412.53,330l-11.61-.86s-6.75,0-11-10,9.5-11.5,10.25-10c.57,1.13,15,5.84,22,8.07Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fdc2cc"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M425.92,318.37l-1.5,12.5L412.53,330c1.94-2.88,6-8.15,9.65-12.79Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M424.42,319.62s13.56,3.13,22.92,6.55c-.62,1-4.76,7.48-9.17,10.31-5.13.14-9.64-.51-10.75-2.36C424.42,329.12,424.42,319.62,424.42,319.62Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M448.72,335.18l-.22-1.73s-.1-.37-.19-.93c-.18-1.14-.31-3.06.53-4.23.49-.69.38-1.18.06-1.53,3.63,1.41,6.39,2.85,7,4.11C456.76,332.55,453.41,334.13,448.72,335.18Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M491.17,327s-13.58,13.59-14.42,16.5-26.5,3-26.5,3l-1.75-14s-.1-.37-.19-.93c-.18-1.14-.31-3.06.53-4.23,1.25-1.75-1.42-2.25-1.42-2.25s-6.92,11.41-12.75,11.75c0,0-8.08,5.83-8,7,0,0-3.92,3.58-4,7.91s-5.08,6.09-8.75,4.84-12.75-3.92-15.67-3.5-12.16,3.16-11.83-5.42c0,0,12-9,15-8.75s10-3.25,11-6,18-23.75,18-23.75S441.17,299,445.5,298c0,0,8.67-6.75,21.75,3.5,0,0,18.09,11.16,18.67,12.66.46,1.18,5.71,6.22,6.15,10A3.09,3.09,0,0,1,491.17,327Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fdc2cc"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M448.75,307.12s1.33,7.67.67,10.42-2,7.5-2,7.5S455.5,312.37,448.75,307.12Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M449.33,325.79s4.17-4.59,5.09-3.42S449.33,325.79,449.33,325.79Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M620.05,279a29.26,29.26,0,0,1-21.24,28.14,28.78,28.78,0,0,1-7.87,1.12h-.15A29.25,29.25,0,0,1,561.55,279a27.86,27.86,0,0,1,.46-5.12,29.2,29.2,0,0,1,26.66-24c.7-.06,1.41-.09,2.12-.09A29.25,29.25,0,0,1,620.05,279Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#f8bdc5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M635.48,275.41a10.29,10.29,0,0,1,2.38,6.06c-2.92.27-6,.62-8.32,2.45-2,1.56-3,4-4,6.27q-1.37,3.21-2.72,6.42c-1.42,3.35-2.88,6.77-5.35,9.44a18.48,18.48,0,0,0-2.78,3.22c-.69,1.25-1,2.83-2.12,3.67a4,4,0,0,1-3.78.21c-1.23-.46-2.33-1.23-3.56-1.72a11.33,11.33,0,0,0-2.45-.64h0c-3.66-.54-7.69.25-10.8-1.72a6.44,6.44,0,0,1-1-.82,9.68,9.68,0,0,1-2.55-4.32,4.86,4.86,0,0,1-.24-2.07,4.47,4.47,0,0,1,2.32-3c.17-.1.34-.2.52-.29,3-1.57,7.17-1.94,8.74-5,1.5-2.9-.36-6.43-2.64-8.77-1.08-1.1-2.36-2.35-2.21-3.89.14-1.36,1.35-2.31,2.36-3.22a17.52,17.52,0,0,0,5.48-9.83,7.47,7.47,0,0,0-.06-3.55,9.41,9.41,0,0,0-1.27-2.33l-3.24-4.8a13.17,13.17,0,0,0-4-4.24c-1.35-.81-2.9-1.09-4.26-1.89a3.38,3.38,0,0,1-1.26-1.2,1.29,1.29,0,0,1-.16-.94c.17-.8,1-1.19,1.83-1.42a17.83,17.83,0,0,1,6.62-.63,5.14,5.14,0,0,0,2.14,0,1.51,1.51,0,0,0,1.11-1.63c2.46-.64,4.79,1.28,6.59,3.08s4,3.77,6.54,3.26c.91-.18,1.75-.7,2.67-.8s2.06.5,2,1.43-1.22,1.53-1.12,2.43a1.79,1.79,0,0,0,.41.84,21.14,21.14,0,0,0,4.07,4.22c0-1.77,0-3.55,0-5.32,2,.5,2.73,3.06,2.5,5.13s-1,4.16-.52,6.18a2.27,2.27,0,0,0,1.2,1.63,3,3,0,0,0,1.57,0c4.59-.65,9.95.57,12.23,4.6l-4-1.45L639,273a4.89,4.89,0,0,1,1.66,1.25,1.66,1.66,0,0,1,.12,1.94A6.21,6.21,0,0,0,635.48,275.41Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#585268"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.67,267.08a3,3,0,0,0,1.57,0c.45-.06.9-.1,1.36-.13a16.12,16.12,0,0,0-3,.09Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.43,270.26l1.72.95-.32-.45Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.53,259.46c0-1.16,0-2.33,0-3.5a3.08,3.08,0,0,0-2-1.82l0,3.52A21.5,21.5,0,0,0,623.53,259.46Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.43,275.06a6.2,6.2,0,0,1,2.46,1,1.24,1.24,0,0,0,.25-.81A6.36,6.36,0,0,0,638.43,275.06Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,313c-1.23-.46-2.33-1.23-3.56-1.72a11.33,11.33,0,0,0-2.45-.64h0c-3.66-.54-7.69.25-10.8-1.72a6.44,6.44,0,0,1-1-.82,9.68,9.68,0,0,1-2.55-4.32,4.86,4.86,0,0,1-.24-2.07,4.47,4.47,0,0,1,2.32-3c.17-.1.34-.2.52-.29,3.05-1.57,7.17-1.94,8.74-5,1.5-2.9-.36-6.43-2.64-8.77-1.08-1.1-2.36-2.35-2.21-3.89.14-1.36,1.35-2.31,2.36-3.22a17.52,17.52,0,0,0,5.48-9.83,7.47,7.47,0,0,0-.06-3.55,9.41,9.41,0,0,0-1.27-2.33l-3.24-4.8a13.17,13.17,0,0,0-4-4.24c-1.35-.81-2.9-1.09-4.26-1.89a3.38,3.38,0,0,1-1.26-1.2,1.29,1.29,0,0,1-.16-.94c.17-.8,1.05-1.19,1.83-1.42a18.49,18.49,0,0,1,4-.66,18,18,0,0,0-6,.66c-.78.23-1.66.62-1.83,1.42a1.29,1.29,0,0,0,.16.94,3.38,3.38,0,0,0,1.26,1.2c1.36.8,2.91,1.08,4.26,1.89a13.17,13.17,0,0,1,4,4.24l3.24,4.8a9.41,9.41,0,0,1,1.27,2.33,7.47,7.47,0,0,1,.06,3.55,17.52,17.52,0,0,1-5.48,9.83c-1,.91-2.22,1.86-2.36,3.22-.15,1.54,1.13,2.79,2.21,3.89,2.28,2.34,4.14,5.87,2.64,8.77-1.57,3.05-5.69,3.42-8.74,5-.18.09-.35.19-.52.29a4.47,4.47,0,0,0-2.32,3,4.86,4.86,0,0,0,.24,2.07,9.68,9.68,0,0,0,2.55,4.32,6.44,6.44,0,0,0,1,.82c3.11,2,7.14,1.18,10.8,1.72h0a11.33,11.33,0,0,1,2.45.64c1.23.49,2.33,1.26,3.56,1.72a4.72,4.72,0,0,0,2.82.24A5.91,5.91,0,0,1,611,313Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.5,251.34a14.7,14.7,0,0,0,1.81-.59,2.15,2.15,0,0,0-1.14-.21,21.06,21.06,0,0,0-2.5.76A4.17,4.17,0,0,0,615.5,251.34Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.12,246.68a5.14,5.14,0,0,0,2.14-.05,1.51,1.51,0,0,0,1.11-1.62,4,4,0,0,0-2,0,1.51,1.51,0,0,1-1.11,1.63,1.6,1.6,0,0,1-.21.05Z",
    transform: "translate(-62.73 -29.63)"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M564.42,263c-3.73,2.79-9.68,4-15.15,4.4a81.37,81.37,0,0,1-12.85,0l-9.63-3.62s.78-1.55,2.1-3.6c2.63-4.08,7.41-10.15,12.4-9.9,7.5.37,15.38.74,16.13.74S572.79,256.75,564.42,263Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fdc2cc"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M540.06,62.83c-7.12-.13-14.47-.21-21,2.53C505.93,70.79,499.74,85.3,491.8,97a90.49,90.49,0,0,1-24.75,24.51c-4.6,3-9.94,6.3-11.05,11.7-1.18,5.71,2.9,11,5,16.41,4.45,11.51,0,24.26-2.63,36.32A117.9,117.9,0,0,0,456,203.52a24.4,24.4,0,0,0,.53,8.18c2,7.06,9.56,12.16,9.62,19.5,0,5-3.52,9.72-2.49,14.58,1.33,6.21,8.87,8.45,15.12,9.52a7.73,7.73,0,0,0,4.55-.14c1-.48,1.82-1.4,2.84-1.91,3.47-1.72,7.32,1.91,11.2,1.84,4.87-.09,7.61-5.84,7.73-10.71s-1.18-10,.57-14.5c2.33-6,9-8.85,14.63-12,6.23-3.49,12.16-8.53,14-15.42,1.15-4.26.63-8.77.17-13.15-.7-6.72-1.25-13.47-1.63-20.21-1-17.2,13.29-31.53,30.46-30.19l.32,0c5,.41,10.9.89,14.43-2.75,1.4-1.45,2.29-3.45,4-4.45,3.34-1.9,7.93.81,11.29-1.06,2.63-1.47,3.19-5,2.78-8s-1.46-6-.9-8.94c.8-4.17,4.59-7.15,6-11.16,1.62-4.57-.13-9.68-2.65-13.82C590.5,75.42,574.07,65,558.67,63.6,552.48,63,546.27,62.93,540.06,62.83Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#865a61"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M528.89,260.15c5.94,1.22,13.17,3.93,20.38,7.24a81.37,81.37,0,0,1-12.85,0l-9.63-3.62S527.57,262.2,528.89,260.15Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M602.79,310.79c-3.66-.54-7.69.25-10.8-1.72a6.44,6.44,0,0,1-1-.82h-.15A29.25,29.25,0,0,1,561.55,279a27.86,27.86,0,0,1,.46-5.12c10.25,5.73,18.56,11.62,20.16,14.5a59.52,59.52,0,0,0,8.3,10.47c2.79,3,5.78,5.88,8.34,8.29C600.33,308.55,601.7,309.8,602.79,310.79Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M604.42,314.12s-18.25-15.75-23.25-24.75-75.25-47.25-66.25-18.25,40,31.75,40,31.75,10,11.25,11,16.75,4.5,13.5,4.5,13.5l16.75,7.5,7.75-1.75S613.17,328.87,604.42,314.12Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fdc2cc"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M569.42,332.12s29.5,16.75,32.5-22.5l7.5,2.5-7.5,26.5-12.75,9.25S571.42,339.62,569.42,332.12Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M570.42,333.12s29.5,16.75,32.5-22.5l7.5,2.5-7.5,26.5-12.75,9.25S572.42,340.62,570.42,333.12Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#d39999"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M596.47,134.22c.34-3.51,1.77-6.82,2.52-10.27a27.13,27.13,0,0,0,.3-10.16,14.75,14.75,0,0,0-2.64-6.76c-1-1.25-4-4-5.75-2.76-1,.71-1.27,4.82-1.67,6a51.81,51.81,0,0,1-5.6,11.25,45.74,45.74,0,0,1-37,72.58c-1.09,0-2.17-.05-3.24-.13-1,1.74-1.91,3.5-2.83,5.26a16.34,16.34,0,0,0-2.16,5.83,15.18,15.18,0,0,0,.89,5.8,81.81,81.81,0,0,0,7.66,17.49,26.45,26.45,0,0,1,2.75,5.47c.57,1.85.67,3.83,1.41,5.61,1.66,4,6,6,10,7.67,2.39,1,4.89,2,7.47,1.79a1.74,1.74,0,0,0,1.87-1.77,6.77,6.77,0,0,0-2-5.75,28.7,28.7,0,0,0,10.5,1.25,1.69,1.69,0,0,0,1.82-2.48,45,45,0,0,0-4.18-10.82c-1.82-3.36-4.14-7.27-2.48-10.7.95-2,2.95-3.12,4.77-4.31,6.15-4,11.6-10.52,11.12-17.85-.26-4-2.28-7.81-2.4-11.84-.31-9.83,10.27-16.86,11.87-26.57C600.74,150.11,595.7,142.25,596.47,134.22Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#865a61"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.61,227.2c-.06-7.34-7.61-12.44-9.62-19.5a16.42,16.42,0,0,1-.57-3.41,22.46,22.46,0,0,0,.57,7.41c1.84,6.45,8.28,11.27,9.43,17.66A12,12,0,0,0,465.61,227.2Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.83,251.09c-3.88.07-7.73-3.56-11.2-1.84-1,.51-1.8,1.43-2.84,1.91a7.73,7.73,0,0,1-4.55.14c-6.23-1.07-13.75-3.3-15.1-9.46a10.24,10.24,0,0,0,0,3.94c1.33,6.21,8.87,8.45,15.12,9.52a7.73,7.73,0,0,0,4.55-.14c1-.48,1.82-1.4,2.84-1.91,3.47-1.72,7.32,1.91,11.2,1.84,4.87-.09,7.61-5.84,7.73-10.71,0-1,0-2-.07-3C504,246,501.36,251,496.83,251.09Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.78,198.45c-1.86,6.89-7.79,11.93-14,15.42-5.63,3.16-12.3,6-14.63,12a19.13,19.13,0,0,0-.86,8.05,14.16,14.16,0,0,1,.86-4.05c2.33-6,9-8.85,14.63-12,6.23-3.49,12.16-8.53,14-15.42a25.28,25.28,0,0,0,.63-8A20.57,20.57,0,0,1,533.78,198.45Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.53,127.3c-2.41-.18-4.92-.74-7,.42-1.75,1-2.64,3-4,4.45-3.53,3.64-9.38,3.16-14.43,2.75l-.32,0c-17.17-1.34-31.44,13-30.46,30.19,0,.13,0,.27,0,.4a28.47,28.47,0,0,1,30.44-26.59l.32,0c5,.41,10.9.89,14.43-2.75,1.4-1.45,2.29-3.45,4-4.45,2-1.16,4.55-.6,7-.42a45.58,45.58,0,0,1,3.25,15c0-.65.05-1.3.05-2A45.68,45.68,0,0,0,588.53,127.3Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.33,158.44a30.89,30.89,0,0,0-1.83-12.8c-1.58-4.09-4.29-8.1-5-12.27-1.09,5.65,2.94,10.88,5,16.27A28.68,28.68,0,0,1,462.33,158.44Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.05,116.12a26,26,0,0,1-.56,3.83c-.75,3.45-2.18,6.76-2.52,10.27a19.68,19.68,0,0,0,0,3.76c.38-3.42,1.75-6.66,2.49-10A27.09,27.09,0,0,0,599.05,116.12Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.93,154.07c-1.6,9.71-12.18,16.74-11.87,26.57a13.81,13.81,0,0,0,.14,1.59c1.26-8.61,10.27-15.26,11.73-24.16a18.49,18.49,0,0,0,.1-4.87C599,153.49,599,153.78,598.93,154.07Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.75,98.53a28,28,0,0,1-3.6,6,13.88,13.88,0,0,1,1,2.52,19.88,19.88,0,0,0,2.57-4.57,12,12,0,0,0,.46-5.8A10.57,10.57,0,0,1,600.75,98.53Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.34,195.39c-.89,6.12-5.68,11.45-11,14.94-1.82,1.19-3.82,2.35-4.77,4.31a6.62,6.62,0,0,0-.27,4.68,4.37,4.37,0,0,1,.27-.68c.95-2,2.95-3.12,4.77-4.31,6.15-4,11.6-10.52,11.12-17.85C589.44,196.11,589.39,195.75,589.34,195.39Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.34,244.47a2.14,2.14,0,0,1-1.29.44c-2.58.22-5.08-.79-7.47-1.79-4-1.66-8.36-3.68-10-7.67-.74-1.78-.84-3.76-1.41-5.61a26.45,26.45,0,0,0-2.75-5.47,81.81,81.81,0,0,1-7.66-17.49,26.91,26.91,0,0,1-.72-2.81c-.07.33-.13.67-.17,1a15.18,15.18,0,0,0,.89,5.8,81.81,81.81,0,0,0,7.66,17.49,26.45,26.45,0,0,1,2.75,5.47c.57,1.85.67,3.83,1.41,5.61,1.66,4,6,6,10,7.67,2.39,1,4.89,2,7.47,1.79a1.74,1.74,0,0,0,1.87-1.77,6.63,6.63,0,0,0-.3-3A1.21,1.21,0,0,1,569.34,244.47Z",
    transform: "translate(-62.73 -29.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.72,238.33a3.19,3.19,0,0,1-1.31.31,28.7,28.7,0,0,1-10.5-1.25,6.75,6.75,0,0,1,2.05,4.55,28.59,28.59,0,0,0,8.45.7,1.69,1.69,0,0,0,1.82-2.48C580.08,239.54,579.9,238.93,579.72,238.33Z",
    transform: "translate(-62.73 -29.63)"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M440.17,260.37s-1,20.5,2,22S440.17,260.37,440.17,260.37Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M496.92,314.37c1,0,5,2,5.5,4.25S496.92,314.37,496.92,314.37Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M494.42,317.62c1,0,5,2,5.5,4.25S494.42,317.62,494.42,317.62Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M503.67,326.62c1,0,5,2,5.5,4.25S503.67,326.62,503.67,326.62Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M491.17,327s-13.58,13.59-14.42,16.5-26.5,3-26.5,3l-1.75-14s-.1-.37-.19-.93c7.09-1.82,30.08-10.31,43.76-7.3A3.09,3.09,0,0,1,491.17,327Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M429.33,344.2s13.09-11.58,17.09-11.33,52.75-20.5,56,2.75-62.25,24.5-62.25,24.5l-10,3.75S421.83,345.7,429.33,344.2Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fdc2cc"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M425.5,345.87s6-8.33,7.83,1.83,4.59,22.67,4.59,22.67L424.5,363.7Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#d39999"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 918.38,
    cy: 664.49,
    rx: 44.79,
    ry: 6.87,
    fill: "#fbe1e5",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 791.95,
    cy: 788.53,
    rx: 70,
    ry: 10.74,
    fill: "#fbe1e5",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 981.95,
    cy: 826.53,
    rx: 92.59,
    ry: 14.21,
    fill: "#fbe1e5",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70,
    cy: 678.54,
    rx: 70,
    ry: 10.74,
    fill: "#fbe1e5",
    opacity: 0.1
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M945.79,628.21s-6.33,29.5,21.85,33l1.75-3.28S947.54,637.39,945.79,628.21Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M978.35,657.7l-6.55,1.39-.66.15s-17.48-14.2-17.26-45.89a79.56,79.56,0,0,0,8.35,13.22C969.16,635.73,977,648,978.35,657.7Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M980.57,660.74a4.1,4.1,0,0,1-3.53.46c-16.83-3.93-11.14-58.77-11.14-58.77.93.44,2,7.41,5.82,16.42C978.51,634.67,986,656.77,980.57,660.74Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.89,628.21s1.1,29.5-27.09,33l-1.75-3.28S1016.15,637.39,1017.89,628.21Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.81,613.35c.21,31.69-22.5,45.89-22.5,45.89l-.66-.15-6.55-1.39c1.29-9.73,9.19-22,16.11-31.13A70.9,70.9,0,0,1,1009.81,613.35Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M986.55,657.87a10.39,10.39,0,0,1-3.75,2.87h0a6.69,6.69,0,0,1-1.37.46c-4.15,1-5.59-2-5.35-7.09.39-9,6.07-24.7,11.17-36.42,3.67-8.44,9.67-14.84,10.56-15.26C997.79,602.43,997.54,645.13,986.55,657.87Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M981.84,583.2s-18.79,66.64-2.62,76.69S986,589.1,981.84,583.2Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M945.79,628.21s-6.33,29.5,21.85,33l1.75-3.28S947.54,637.39,945.79,628.21Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M978.35,657.7l-6.55,1.39-.66.15s-17.48-14.2-17.26-45.89a79.56,79.56,0,0,0,8.35,13.22C969.16,635.73,977,648,978.35,657.7Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M980.57,660.74a4.1,4.1,0,0,1-3.53.46c-16.83-3.93-11.14-58.77-11.14-58.77.93.44,2,7.41,5.82,16.42C978.51,634.67,986,656.77,980.57,660.74Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.89,628.21s1.1,29.5-27.09,33l-1.75-3.28S1016.15,637.39,1017.89,628.21Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.81,613.35c.21,31.69-22.5,45.89-22.5,45.89l-.66-.15-6.55-1.39c1.29-9.73,9.19-22,16.11-31.13A70.9,70.9,0,0,1,1009.81,613.35Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M986.55,657.87a10.39,10.39,0,0,1-3.75,2.87h0a6.69,6.69,0,0,1-1.37.46c-4.15,1-5.59-2-5.35-7.09.39-9,6.07-24.7,11.17-36.42,3.67-8.44,9.67-14.84,10.56-15.26C997.79,602.43,997.54,645.13,986.55,657.87Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M981.84,583.2s-18.79,66.64-2.62,76.69S986,589.1,981.84,583.2Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M945.79,628.21s-3.71,29.5,24.47,33l1.75-3.28S947.54,637.39,945.79,628.21Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M981,657.7l-6.55,1.39-.66.15s-20.1-14.2-19.88-45.89c0,0,5.15,5.52,11,13.22C971.79,635.73,979.66,648,981,657.7Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M981,657.7l-6.55,1.39c-6.21-5.45-8.68-19.69-9.57-32.52C971.79,635.73,979.66,648,981,657.7Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M983.19,660.74a4.1,4.1,0,0,1-3.53.46c-16.83-3.93-13.76-58.77-13.76-58.77.93.44,4.57,7.41,8.44,16.42C981.13,634.67,988.59,656.77,983.19,660.74Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.89,628.21s3.72,29.5-24.47,33l-1.74-3.28S1016.15,637.39,1017.89,628.21Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.81,613.35c.21,31.69-19.88,45.89-19.88,45.89l-.66-.15-6.55-1.39c1.3-9.73,9.19-22,16.11-31.13C1004.66,618.87,1009.81,613.35,1009.81,613.35Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M998.83,626.57c-.84,12-3,25.14-8.35,31.3a10,10,0,0,1-1.21,1.22l-6.55-1.39C984,648,991.91,635.73,998.83,626.57Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M989.17,657.87a10.31,10.31,0,0,1-3.75,2.87h0a7,7,0,0,1-1.38.46c-4.14,1-5.59-2-5.35-7.09.39-9,6.07-24.7,11.17-36.42,3.67-8.44,7-14.84,7.94-15.26C997.79,602.43,1000.17,645.13,989.17,657.87Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M983.19,660.74a4.61,4.61,0,0,1-2.66-.85c-7.92-4.93-8.08-23.44-6.19-41C981.13,634.67,988.59,656.77,983.19,660.74Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M989.17,657.87c-.91,2-2.14,3-3.75,2.87h0a5.25,5.25,0,0,1-2.26-.85,12,12,0,0,1-4.47-5.78c.39-9,6.07-24.7,11.17-36.42C991.67,634,992.27,651.2,989.17,657.87Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M981.84,583.2s-16.16,66.64,0,76.69S986,589.1,981.84,583.2Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    points: "950.14 626.99 882.85 626.99 882.85 638.13 893.11 638.13 893.37 639.44 897.48 661.07 936.6 661.07 940.71 639.44 940.96 638.13 950.14 638.13 950.14 626.99",
    fill: "#4b4770"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    points: "950.14 626.99 882.85 626.99 882.85 638.13 893.11 638.13 893.37 639.44 897.48 661.07 936.6 661.07 940.71 639.44 940.96 638.13 950.14 638.13 950.14 626.99",
    opacity: 0.1
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    points: "944.46 633.54 943.34 639.44 939.22 661.07 900.1 661.07 895.99 639.44 894.86 633.54 944.46 633.54",
    fill: "#4b4770"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    points: "944.46 633.54 943.34 639.44 895.99 639.44 894.86 633.54 944.46 633.54",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 885.47,
    y: 626.99,
    width: 67.29,
    height: 11.14,
    fill: "#4b4770"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M171.88,590.79a17.18,17.18,0,0,0-2.28,4.29c-.14.37-.28.8-.42,1.21a3.69,3.69,0,0,0-.79-.27,11.05,11.05,0,0,0-3.57-.31c0-.46.06-1,.07-1.47.15-5.27-.47-12.61-5.5-9.5-4.82,3-1.38,8,1.73,11.2.27.28.54.54.8.79-2.84,2-3.38,6.73-3.85,11.64s-4.64,10.28-7.41,13.34c-.28.31-.53.59-.78.85a10.1,10.1,0,0,0-8-2.07c-.11-.43-.23-.88-.37-1.36C139.22,611,134.58,597,128.64,594c.25-.31.51-.63.78-1,2.52-3.3,5.36-8.2,1.17-9.45s-4.57,4.25-4.34,8.37c0,.51.08,1,.12,1.46A6.14,6.14,0,0,0,122,595.5l-.65-.77c-3.4-4-9.63-10.36-11.52-5.55-1.75,4.47,3.73,10.29,7.59,13.66l.24.21c-2.59,10.52,8.72,19.09,14.81,22.83l.79.49c-8.4,9.89-13.59,28.45-13.59,28.45l23.53,4.2s15.59-13.46,13.59-26.09l.16,0c15.59-3.13,19.13-19.75,16.71-29.61l.27-.12a17.7,17.7,0,0,0,7.22-5.45C185.5,591.68,176.36,584.84,171.88,590.79Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M171.88,590.79a17.18,17.18,0,0,0-2.28,4.29c-.14.37-.28.8-.42,1.21a3.69,3.69,0,0,0-.79-.27,11.05,11.05,0,0,0-3.57-.31c0-.46.06-1,.07-1.47.15-5.27-.47-12.61-5.5-9.5-4.82,3-1.38,8,1.73,11.2.27.28.54.54.8.79-2.84,2-3.38,6.73-3.85,11.64s-4.64,10.28-7.41,13.34c-.28.31-.53.59-.78.85a10.1,10.1,0,0,0-8-2.07c-.11-.43-.23-.88-.37-1.36C139.22,611,134.58,597,128.64,594c.25-.31.51-.63.78-1,2.52-3.3,5.36-8.2,1.17-9.45s-4.57,4.25-4.34,8.37c0,.51.08,1,.12,1.46A6.14,6.14,0,0,0,122,595.5l-.65-.77c-3.4-4-9.63-10.36-11.52-5.55-1.75,4.47,3.73,10.29,7.59,13.66l.24.21c-2.59,10.52,8.72,19.09,14.81,22.83l.79.49c-8.4,9.89-13.59,28.45-13.59,28.45l23.53,4.2s15.59-13.46,13.59-26.09l.16,0c15.59-3.13,19.13-19.75,16.71-29.61l.27-.12a17.7,17.7,0,0,0,7.22-5.45C185.5,591.68,176.36,584.84,171.88,590.79Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M125.06,597.57l-2.75,8s-1.53-1.08-3.46-2.78c-3.86-3.37-9.34-9.19-7.59-13.66,1.89-4.81,8.12,1.54,11.52,5.55C124.15,596.33,125.06,597.57,125.06,597.57Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M130.86,593a38.89,38.89,0,0,1-2.68,3.15,42.22,42.22,0,0,1-.49-4.23c-.23-4.12.21-9.59,4.34-8.37S133.38,589.68,130.86,593Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M166.33,594.24c-.08,2.65-.34,4.77-.34,4.77a33.41,33.41,0,0,1-3.43-3.07c-3.11-3.22-6.55-8.2-1.73-11.2C165.86,581.63,166.48,589,166.33,594.24Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M182.58,597.72a17.7,17.7,0,0,1-7.22,5.45,19.38,19.38,0,0,1-2.42.88l-3.24-4.55a33.05,33.05,0,0,1,1.34-4.42,17.18,17.18,0,0,1,2.28-4.29C177.8,584.84,186.94,591.68,182.58,597.72Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M122.78,594.73c1.37,1.6,2.28,2.84,2.28,2.84l-2.75,8s-1.53-1.08-3.46-2.78a15.7,15.7,0,0,1,3.1-7.07C122.22,595.4,122.51,595.05,122.78,594.73Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M130.86,593a38.89,38.89,0,0,1-2.68,3.15,42.22,42.22,0,0,1-.49-4.23A5.46,5.46,0,0,1,130.86,593Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M144.39,624.93l-6.85,3s-1.49-.72-3.64-2.06c-7.19-4.42-21.64-15.55-12-28.67s17.77,10.41,21,21.92C143.87,622.57,144.39,624.93,144.39,624.93Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M162.56,595.94a5.64,5.64,0,0,1,3.77-1.7c-.08,2.65-.34,4.77-.34,4.77A33.41,33.41,0,0,1,162.56,595.94Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M175.36,603.17a19.38,19.38,0,0,1-2.42.88l-3.24-4.55a33.05,33.05,0,0,1,1.34-4.42C173.13,596.3,174.67,599.34,175.36,603.17Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M158.38,632.9l-1.15.2c-22.93,3.48-7.56-8.89-7.56-8.89s1-1,2.43-2.5c2.77-3.06,6.93-8.4,7.41-13.34.72-7.43,1.55-14.4,10.32-12.35C178.44,598,180.09,628.55,158.38,632.9Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.41,
    y: 660.36,
    width: 43.81,
    height: 11.52,
    fill: "#d4dfec"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.45,
    y: 622.91,
    width: 57.24,
    height: 40.2,
    fill: "#d4dfec"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51.41,
    y: 660.36,
    width: 43.81,
    height: 11.52,
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44.45,
    y: 622.91,
    width: 57.24,
    height: 40.2,
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54.29,
    y: 660.36,
    width: 43.81,
    height: 11.52,
    fill: "#d4dfec"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M142.9,619.13c1,3.44,1.49,5.8,1.49,5.8l-6.85,3s-1.49-.72-3.64-2.06C136.58,622.49,139.6,619.92,142.9,619.13Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M158.38,632.9l-1.15.2c-22.93,3.48-7.56-8.89-7.56-8.89s1-1,2.43-2.5C156.38,625.13,158.15,629,158.38,632.9Z",
    transform: "translate(-62.73 -29.63)",
    opacity: 0.1
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M121.1,654.82s12.84-46,30.85-31.8-7.32,36-7.32,36Z",
    transform: "translate(-62.73 -29.63)",
    fill: "#fbe1e5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.85,
    cy: 574.79,
    r: 1.44,
    opacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.73,
    cy: 581.51,
    r: 1.44,
    opacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 576.11,
    r: 1.44,
    opacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.89,
    cy: 610.55,
    r: 1.44,
    opacity: 0.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.5,
    cy: 587.27,
    r: 1.44,
    opacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.62,
    cy: 602.15,
    r: 1.44,
    opacity: 0.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.77,
    cy: 577.67,
    r: 1.44,
    opacity: 0.1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.54,
    cy: 580.43,
    r: 1.44,
    opacity: 0.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.62,
    cy: 591.59,
    r: 1.44,
    opacity: 0.1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 609.47,
    r: 1.44,
    opacity: 0.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.38,
    cy: 602.39,
    r: 1.44,
    opacity: 0.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.93,
    cy: 586.43,
    r: 1.44,
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54.29,
    y: 660.36,
    width: 43.81,
    height: 4.21,
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47.33,
    y: 622.91,
    width: 57.24,
    height: 40.2,
    fill: "#d4dfec"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.42,
    cy: 615.95,
    r: 1.44,
    opacity: 0.1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.78,
    cy: 617.75,
    r: 1.44,
    opacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/baby.e31e649cb0e359ccb4c48f5fcc87a999.svg";
export { ForwardRef as ReactComponent };